import React from "react";
import "./PoliciesPages.scss";

const GDPR = () => {
    return (
        <div className="policy-page">
            <h1>GDPR Policy</h1>

            <p><strong>Version:</strong> 1.0</p>
            <p><strong>Date:</strong> 01.01.2025</p>
            <p><strong>Author:</strong> Afzal Mahmood of Ranna</p>
            <p><strong>Stored at:</strong> Policy and Procedure Filing</p>

            <h2>1. Purpose of This GDPR Policy</h2>
            <p>
                Old Kent Shisha Lounge is committed to protecting all personal data handled
                by our business. This policy outlines how we comply with UK GDPR and the
                Data Protection Act 2018.
            </p>

            <h2>2. What is Personal Data?</h2>
            <p>Personal data is information that can identify an individual. This may include:</p>
            <ul>
                <li>Name and contact details</li>
                <li>Date of birth</li>
                <li>Booking information</li>
                <li>CCTV imagery</li>
                <li>Website or device data</li>
            </ul>

            <h2>3. GDPR Principles We Follow</h2>
            <ul>
                <li>Lawfulness, fairness and transparency</li>
                <li>Purpose limitation</li>
                <li>Data minimisation</li>
                <li>Accuracy</li>
                <li>Storage limitation</li>
                <li>Integrity and confidentiality (security)</li>
                <li>Accountability</li>
            </ul>

            <h2>4. Lawful Bases for Processing</h2>
            <ul>
                <li>Consent</li>
                <li>Contractual necessity</li>
                <li>Legal obligation</li>
                <li>Legitimate interests</li>
            </ul>

            <h2>5. Data We Collect</h2>
            <ul>
                <li>Contact information</li>
                <li>Booking and reservation data</li>
                <li>CCTV footage</li>
                <li>Website analytics</li>
            </ul>

            <h2>6. How We Use Personal Data</h2>
            <ul>
                <li>To manage reservations</li>
                <li>To ensure venue safety</li>
                <li>To improve services</li>
                <li>To comply with legal obligations</li>
            </ul>

            <h2>7. Your Rights Under UK GDPR</h2>
            <ul>
                <li>Right to access</li>
                <li>Right to rectification</li>
                <li>Right to erasure</li>
                <li>Right to restrict or object</li>
                <li>Right to data portability</li>
                <li>Right to withdraw consent</li>
            </ul>

            <h2>8. Data Sharing</h2>
            <ul>
                <li>We do not sell personal data.</li>
                <li>We share data only when legally required or operationally necessary.</li>
                <li>All third parties must comply with UK GDPR.</li>
            </ul>

            <h2>9. International Data Transfers</h2>
            <p>
                Data is not transferred outside the UK unless adequate safeguards or legal
                permissions exist.
            </p>

            <h2>10. Data Retention</h2>
            <ul>
                <li>Bookings: up to 12 months</li>
                <li>Enquiries: 6 months</li>
                <li>CCTV: 30–60 days</li>
            </ul>

            <h2>11. Data Security</h2>
            <ul>
                <li>SSL encryption</li>
                <li>Firewalls and intrusion protection</li>
                <li>Secure UK-based servers</li>
                <li>Staff access controls</li>
                <li>Ongoing staff training</li>
            </ul>

            <h2>12. Data Breach Procedure</h2>
            <ul>
                <li>Breach containment and assessment</li>
                <li>ICO notification within 72 hours (if required)</li>
                <li>Customer notification when necessary</li>
                <li>Internal incident logging</li>
            </ul>

            <h2>13. Contact for GDPR Requests</h2>
            <p><strong>Old Kent Shisha Lounge</strong></p>
            <p>Email: hello@oldkent-shisha.co.uk </p>
            <p>Phone: 020 7701 4646 </p>
            <p>Address: <strong>Oldkent Shisha Lounge </strong>
                350 Old Kent Road London SE1 5AA </p>
        </div>
    );
};

export default GDPR;
